// Словарь переводов
export const translations = {
  'ru-RU': {
    appTitle: 'Matriarch - Поиск фильмов и сериалов онлайн',
    menu: 'Меню',
    settings: 'Настройки',
    lightTheme: 'Светлая тема',
    darkTheme: 'Тёмная тема',
    language: 'Русский',
    profile: 'Профиль',
    profileName: 'Имя',
    profileNamePlaceholder: 'Ваше имя',
    changeAvatar: 'Сменить аватар',
    favorites: 'Избранное',
    watched: 'Просмотренное',
    watchlist: 'Буду смотреть',
    favoritesEmpty: 'В избранном пока пусто',
    watchedEmpty: 'Вы ещё ничего не посмотрели',
    watchlistEmpty: 'Список "Буду смотреть" пуст',
    onKinopoisk: 'На Кинопоиске',
    removeFromList: 'Удалить из списка',
    movie: 'Фильм',
    tvSeries: 'Сериал',
    filters: 'Фильтры',
    contentType: 'Тип контента',
    all: 'Все',
    movies: 'Фильмы',
    tv: 'Сериалы',
    anime: 'Аниме',
    animeOnly: 'Только аниме (Япония + Анимация)',
    genre: 'Жанр',
    allGenres: 'Все жанры',
    year: 'Год выпуска',
    allYears: 'Все годы',
    rating: 'Минимальный рейтинг',
    sortBy: 'Сортировка',
    byPopularity: 'По популярности',
    byRating: 'По рейтингу',
    byDateNew: 'По дате (новые)',
    byDateOld: 'По дате (старые)',
    byTitleAZ: 'По названию (А-Я)',
    byTitleZA: 'По названию (Я-А)',
    reset: 'Сбросить',
    apply: 'Применить',
    trailerNotFound: 'Трейлер не найден',
    trailerNotFoundText: 'К сожалению, трейлер для «',
    notFound: 'не найден.',
    kinopoisk: 'На Кинопоиске',
    close: 'Закрыть',
    searchPlaceholder: 'Поиск фильмов и сериалов...',
    noResults: 'Ничего не найдено',
    page: 'Страница',
    cache: 'Кэш',
    cacheActive: 'Активных:',
    cacheSize: 'Размер:',
    cacheClear: 'Очистить кэш',
    showAtom: 'Показать атом',
    hideAtom: 'Скрыть атом',
    lists: 'Списки',
    categories: 'Категории',
    allCategories: 'Все',
    categoryMovies: 'Фильмы',
    categoryTV: 'Сериалы',
    categoryAnime: 'Аниме',
    syncErrorAccountLinked: 'Этот аккаунт уже привязан к другому пользователю',
    syncDisabled: 'Синхронизация отключена',
    logout: 'Выйти',
    synced: 'Синхронизировано',
    // Мессенджер
    messenger: 'Мессенджер',
    noMessagesYet: 'Пока нет сообщений',
    startConversation: 'Начните общение!',
    typeMessage: 'Сообщение',
    noChats: 'Нет чатов',
    startNewChat: 'Начать новый чат',
    newChat: 'Новый чат',
    selectUser: 'Выберите собеседника',
    searchUser: 'Поиск по имени или email...',
    noUsersFound: 'Пользователи не найдены',
    users: 'Пользователи',
    notifications: 'Уведомления',
    noNotifications: 'Нет уведомлений',
    sharedContent: 'Поделённый контент',
    noSharedContent: 'Никто не делился контентом',
    share: 'Поделиться',
    shareWith: 'Поделиться с',
    shareMessage: 'Сообщение (необязательно)',
    shareSent: 'Контент отправлен!',
    markAllRead: 'Прочитать все',
    unreadMessages: 'непрочитанных сообщений'
  },
  'en-US': {
    appTitle: 'Matriarch - Movies and TV Shows Search',
    menu: 'Menu',
    settings: 'Settings',
    lightTheme: 'Light Theme',
    darkTheme: 'Dark Theme',
    language: 'English',
    profile: 'Profile',
    profileName: 'Name',
    profileNamePlaceholder: 'Your name',
    changeAvatar: 'Change avatar',
    favorites: 'Favorites',
    watched: 'Watched',
    watchlist: 'Watchlist',
    favoritesEmpty: 'No favorites yet',
    watchedEmpty: 'You haven\'t watched anything yet',
    watchlistEmpty: 'Your watchlist is empty',
    onKinopoisk: 'On Kinopoisk',
    removeFromList: 'Remove from list',
    movie: 'Movie',
    tvSeries: 'TV Series',
    filters: 'Filters',
    contentType: 'Content Type',
    all: 'All',
    movies: 'Movies',
    tv: 'TV Shows',
    anime: 'Anime',
    animeOnly: 'Anime Only (Japan + Animation)',
    genre: 'Genre',
    allGenres: 'All Genres',
    year: 'Release Year',
    allYears: 'All Years',
    rating: 'Minimum Rating',
    sortBy: 'Sort By',
    byPopularity: 'By Popularity',
    byRating: 'By Rating',
    byDateNew: 'By Date (Newest)',
    byDateOld: 'By Date (Oldest)',
    byTitleAZ: 'By Title (A-Z)',
    byTitleZA: 'By Title (Z-A)',
    reset: 'Reset',
    apply: 'Apply',
    trailerNotFound: 'Trailer Not Found',
    trailerNotFoundText: 'Unfortunately, trailer for «',
    notFound: 'not found.',
    kinopoisk: 'On Kinopoisk',
    close: 'Close',
    searchPlaceholder: 'Search movies and TV shows...',
    noResults: 'Nothing found',
    page: 'Page',
    cache: 'Cache',
    cacheActive: 'Active:',
    cacheSize: 'Size:',
    cacheClear: 'Clear cache',
    showAtom: 'Show atom',
    hideAtom: 'Hide atom',
    lists: 'Lists',
    categories: 'Categories',
    allCategories: 'All',
    categoryMovies: 'Movies',
    categoryTV: 'TV Shows',
    categoryAnime: 'Anime',
    syncErrorAccountLinked: 'This account is already linked to another user',
    syncDisabled: 'Sync disabled',
    logout: 'Logout',
    synced: 'Synced',
    // Messenger
    messenger: 'Messenger',
    noMessagesYet: 'No messages yet',
    startConversation: 'Start a conversation!',
    typeMessage: 'Message',
    noChats: 'No chats',
    startNewChat: 'Start new chat',
    newChat: 'New chat',
    selectUser: 'Select a user',
    searchUser: 'Search by name or email...',
    noUsersFound: 'No users found',
    users: 'Users',
    notifications: 'Notifications',
    noNotifications: 'No notifications',
    sharedContent: 'Shared content',
    noSharedContent: 'No shared content yet',
    share: 'Share',
    shareWith: 'Share with',
    shareMessage: 'Message (optional)',
    shareSent: 'Content sent!',
    markAllRead: 'Mark all as read',
    unreadMessages: 'unread messages'
  }
};
